import React, {Component} from 'react';
import './Logo.css';
import {FormattedMessage} from 'react-intl';

class Logo extends Component {

    render() {
        

        return (
            <div className="logo_link">
                <FormattedMessage id='logo'
                                  description='say hello to Howard.'
                                  defaultMessage='{logo_str}'
                                  values={{logo_str: this.props.logo,}}
                ></FormattedMessage>
            </div>
        );
    }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js